"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpRequest = void 0;
const serviceConfigs_1 = require("./../configs/serviceConfigs");
const helper_1 = require("./helper");
const httpRequest = async ({ url = '', method = serviceConfigs_1.HTTP_METHOD.GET, headers = { 'content-type': 'application/json' }, data = null !== null && null !== void 0 ? null : '' }, timeoutMillisecond = Number(serviceConfigs_1.DEFAULT_TIMEOUT), options = {}) => {
    if (headers['content-type'] === 'application/json') {
        data = data ? JSON.stringify(data) : null;
    }
    const controller = new AbortController();
    const { signal } = controller;
    return await (0, helper_1.timeout)(timeoutMillisecond, controller, fetch(url, Object.assign({ method: (0, helper_1.overrideMethod)(method), signal, body: data || null, headers: Object.assign(Object.assign({}, headers), (0, helper_1.setXhttpOverrideHeader)(method)) }, options))
        .then(helper_1.handleResponse)
        .then((response) => response));
};
exports.httpRequest = httpRequest;
